import React from "react";
import ReactDOM from "react-dom/client";
import "./styles.css";
import 'bootstrap/dist/css/bootstrap.css';
import App from "./App";
import Forecast from "./Forecast";
import axios from "axios";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
